import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import "./lib/zxcvbnSetup";
import "./index.css";
import { useUi } from "./stores/ui";
import { useSession } from "./stores/session";
import { useMasterSession } from "./stores/masterSession";

if (import.meta.env.DEV) {
  (window as unknown as { __vaultwisp?: unknown }).__vaultwisp = {
    ui: useUi,
    session: useSession,
    masterSession: useMasterSession,
  };
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
);
